import styled from 'styled-components';

import {
  mq,
  borderClipPath,
  getSpace,
  getGridSpans,
  getGridSpan
} from '../../../stylesheets/tools';

const StyledQuoteSlider = styled.section`
  postion: relative;

  .quoteSlider__headline {
    margin-bottom: ${getSpace('m')};
    margin-left: ${getGridSpan('1', 'spread')};

    ${mq('m')} {
      margin-bottom: ${getSpace('l')};
    }
  }

  .quoteSlider__outer {
    position: relative;
    padding: ${getSpace('l')} 0;

    ${mq('m')} {
      padding: ${getSpace('xxl')} 0;
    }

    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: ${props => props.theme.siteTheme.primary};

      clip-path: polygon(100% 90.33%, 100% 9.67%, 78.4% 0%, 0% 7.74%, 0% 94.32%, 78.4% 100%);

      ${mq('m')} {
        padding: 120px 0;
        clip-path: polygon(100% 90%, 100% 12.57%, 78.49% 0%, 0% 12.57%, 0% 90%, 78.49% 99.02%);
      }
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  .swiper-wrapper {
    align-items: end;
    margin-left: ${getGridSpan('1', 'spread')};
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    transform: scale(0.8);
    transition: transform 300ms ease;

    ${getGridSpans('width', { s: 11, m: 9 })}

    &-active {
      transform: scale(1);
    }
  }

  blockquote {
    width: 100%;
    float: none;
  }

  .quoteSlider__meta {
    position: absolute;
    right: 1%;
    bottom: -60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getSpace('m')};
    padding: 0 24px;

    ${mq('m')} {
      flex-direction: row;
      gap: ${getSpace('xl')};
      right: 1%;
      bottom: -100px;
    }
  }

  .quoteSlider__button {
    position: relative;
    ${borderClipPath('#000', '#fff')};
    padding: ${getSpace('xxs')};

    &:after {
      z-index: -1;
    }

    ${mq('m')} {
      padding: ${getSpace('s')};
    }

    svg {
      transition: transform 0.3s ease;
    }
  }

  .quoteSlider__prevButton {
    &:focus,
    &:hover {
      svg {
        transform: translateX(-10px);
      }
    }
  }

  .quoteSlider__nextButton {
    transform: scaleX(-1);
    margin-left: -2px;

    svg {
      transform: scaleX(-1);
    }

    &:focus,
    &:hover {
      svg {
        transform: scaleX(-1) translateX(10px);
      }
    }
  }
`;

export default StyledQuoteSlider;
